import { createStore as reduxCreateStore, Store } from 'redux';

import { Action } from './actions';
import { State } from './models';
import { rootReducer } from './reducers';

export function createStore(): Store<State, Action> {
  const store = reduxCreateStore(
    rootReducer,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
  );

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (process.env.NODE_ENV === 'development' && module.hot) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    module.hot.accept('./reducers', () => {
      store.replaceReducer(rootReducer);
    });
  }
  return store;
}
